import { Box, useTheme } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
	disabled?: boolean;
	onClick?: () => void;
}>;

/**
 * @deprecated Row surface for pre-redesign pages, rendered as a button only
 * when interactive. New screens use Shared/Components/ListRow.
 */
export const DeprecatedRow: FC<Props> = ({
	disabled = false,
	onClick,
	children,
}) => {
	const theme = useTheme();

	const isInteractive = !!onClick && !disabled;

	return (
		<Box
			component={onClick ? "button" : "div"}
			{...(onClick ? { type: "button" as const, disabled } : {})}
			onClick={onClick}
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				width: "100%",
				height: 48,
				m: 0,
				p: 0,
				border: "none",
				bgcolor: "transparent",
				font: "inherit",
				color: "inherit",
				appearance: "none",
				textAlign: "left",
				cursor: isInteractive ? "pointer" : "default",
				opacity: disabled ? 0.5 : 1,
				WebkitTapHighlightColor: "transparent",
				...(isInteractive
					? { "&:active": { bgcolor: theme.palette.deprecated.grey[100] } }
					: {}),
			}}
		>
			{children}
		</Box>
	);
};
